export var HOOK_SETUP = 'devtools-plugin:setup';